module.exports = __webpack_public_path__ + "static/img/1.96683aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/1.png
// module id = TUnH
// module chunks = 0